const KEY = "tt-chime";

export const chimeOn = () => localStorage.getItem(KEY) !== "off";
export const setChime = (on) => localStorage.setItem(KEY, on ? "on" : "off");

let ctx;
const PARTIALS = [[1, 0.5, 4.2], [2.01, 0.22, 2.6], [2.76, 0.14, 2], [5.4, 0.06, 1.1], [8.93, 0.03, 0.7]];

export const playBell = (base = 392) => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  ctx = ctx ?? new AC();
  if (ctx.state === "suspended") ctx.resume();
  const t = ctx.currentTime + 0.02;
  const out = ctx.createGain();
  out.gain.value = 0.28;
  out.connect(ctx.destination);
  PARTIALS.forEach(([ratio, amp, decay]) => {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = base * ratio;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(amp, t + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t + decay);
    osc.connect(g).connect(out);
    osc.start(t);
    osc.stop(t + decay + 0.05);
  });
};
